import type { ChkIconProps } from './ChkIcon.types';
import { ChkSvgWrapper } from './ChkIcon.utils';

export const ChkIconEyeSlash = (iconProps: ChkIconProps) => (
  <ChkSvgWrapper {...iconProps}>
    <path
      d="M4.41431 4L20.4143 20"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M17.3731 16.8967C15.8449 18.061 13.9942 19 12 19C7.67459 19 4.02435 14.5823 2.87579 13.0309C2.63929 12.7114 2.64028 12.2872 2.87681 11.9677C3.66434 10.9042 5.62474 8.49754 8.17147 7.08685"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M10.8833 6.09624C11.2496 6.0337 11.6222 6 11.9999 6C16.3253 6 19.9756 10.4177 21.1242 11.9691C21.3607 12.2886 21.3587 12.7142 21.1221 13.0336C20.8141 13.4495 20.3272 14.0702 19.6963 14.7561"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M14.3201 14.4173C13.7681 15.0846 12.9337 15.5098 12 15.5098C10.3378 15.5098 8.99023 14.1622 8.99023 12.5C8.99023 11.4842 9.49349 10.5859 10.2643 10.0408"
      stroke="currentColor"
      strokeWidth="1.8"
    />
  </ChkSvgWrapper>
);
